module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-carryin-175da5d8806aea41faff6cca96ec114d.png";